// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6057":"b7cb5ad5dfdc9714","9867":"2c628262ea4300a9"}[chunkId] + ".css";
};